import { DataGrid } from '@mui/x-data-grid'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Box } from '@mui/material'

// Create a custom theme that matches our Tailwind styling
const theme = createTheme({
  palette: {
    mode: 'light',
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: '1px solid #e5e7eb', // border-gray-200
          borderRadius: '0.5rem', // rounded-lg
          '& .MuiDataGrid-cell': {
            fontSize: '0.875rem', // text-sm
            color: '#374151', // text-gray-700
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#f9fafb', // bg-gray-50
            fontSize: '0.75rem', // text-xs
            fontWeight: 500,
            color: '#6b7280', // text-gray-500
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 500,
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#f9fafb', // hover:bg-gray-50
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
          },
        },
      },
    },
  },
})

const DataTable = ({
  rows = [],
  columns = [],
  loading = false,
  pageSize = 10,
  pageSizeOptions = [5, 10, 25, 50, 100],
  checkboxSelection = false,
  disableRowSelectionOnClick = false,
  onRowClick = null,
  onRowSelectionModelChange = null,
  height = 400,
  autoHeight = false,
  sortModel = [],
  onSortModelChange = null,
  filterModel = undefined,
  onFilterModelChange = null,
  density = 'standard', // 'compact', 'standard', 'comfortable'
  hideFooter = false,
  hideFooterPagination = false,
  hideFooterRowCount = false,
  sx = {},
  ...otherProps
}) => {
  // Generate unique IDs for rows if they don't have them
  const processedRows = rows.map((row, index) => ({
    id: row.id || index,
    ...row,
  }))

  // Process columns to add default properties
  const processedColumns = columns.map(col => ({
    sortable: true,
    filterable: true,
    ...col,
    headerName: col.headerName || col.field,
  }))

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ height: autoHeight ? 'auto' : height, width: '100%', ...sx }}>
        <DataGrid
          rows={processedRows}
          columns={processedColumns}
          loading={loading}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize },
            },
            filter: {
              filterModel,
            },
          }}
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          pageSizeOptions={pageSizeOptions}
          checkboxSelection={checkboxSelection}
          disableRowSelectionOnClick={disableRowSelectionOnClick}
          onRowClick={onRowClick}
          onRowSelectionModelChange={onRowSelectionModelChange}
          onFilterModelChange={onFilterModelChange}
          density={density}
          hideFooter={hideFooter}
          hideFooterPagination={hideFooterPagination}
          hideFooterRowCount={hideFooterRowCount}
          autoHeight={autoHeight}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-row:focus': {
              outline: 'none',
            },
          }}
          {...otherProps}
        />
      </Box>
    </ThemeProvider>
  )
}

export default DataTable

